/**
 * NavIcon — the nav model's `icon` string → component bridge (RW-68).
 *
 * RW-2378: lifted out of Sidebar.js so the mobile bottom bar resolves icons
 * from the SAME map. It was Sidebar-private, and MobileNav carried a much
 * smaller copy of its own — so a section whose glyph Sidebar knew rendered as
 * the fallback globe on a phone. One more instance of the paired-registry
 * class this ticket is about.
 *
 * The name→component map lives INSIDE the function per CLAUDE.md gotcha #11
 * (never reference imported values in a module-level const — TDZ).
 */
import React from 'react';
// RW-68: in-house Lucide set — nav glyphs are SVG, not emoji.
import FeedIcons from './feedIcons';

export function NavIcon({ name, size = 19, color = 'currentColor', strokeWidth = 1.7, ...rest }) {
  const map = {
    home: FeedIcons.IconHome, message: FeedIcons.IconComment, clipboard: FeedIcons.IconClipboardList,
    key: FeedIcons.IconKey, pen: FeedIcons.IconPencil, building: FeedIcons.IconBuilding,
    settings: FeedIcons.IconSettings, trending: FeedIcons.IconTrendingUp, logout: FeedIcons.IconLogOut,
    users: FeedIcons.IconUsers, briefcase: FeedIcons.IconBriefcase, user: FeedIcons.IconUser,
    target: FeedIcons.IconTarget, wrench: FeedIcons.IconWrench, zap: FeedIcons.IconZap,
    cap: FeedIcons.IconGraduationCap, sparkle: FeedIcons.IconSparkles,
    // RW-1601: Connect-group glyphs.
    calendar: FeedIcons.IconCalendar, megaphone: FeedIcons.IconMegaphone, award: FeedIcons.IconAward,
    bookmark: FeedIcons.IconBookmark, search: FeedIcons.IconSearch, mail: FeedIcons.IconMail,
    heart: FeedIcons.IconHeart, camera: FeedIcons.IconCamera,
    // RW-1599: One Pipeline second-rail glyphs (the DealsShell rail had
    // per-item icons; they ride the shared FeedIcons set now).
    grid: FeedIcons.IconGrid, checkSquare: FeedIcons.IconCheckSquare, eye: FeedIcons.IconEye,
    dollar: FeedIcons.IconDollarSign, landmark: FeedIcons.IconLandmark, shield: FeedIcons.IconShield,
    book: FeedIcons.IconBook, fileText: FeedIcons.IconFileText, mapPin: FeedIcons.IconMapPin,
    penLine: FeedIcons.IconPenLine,
    // RW-1610 Flipbooks
    presentation: FeedIcons.IconPresentation,
    // RW-1785: Help moves to the footer "More" group.
    help: FeedIcons.IconHelpCircle,
    // RW-1786: Deals spine glyph (DA icon set via C_NAV).
    layers: FeedIcons.IconLayers,
    // RW-1818: full item-icon coverage for the mini-rail.
    moon: FeedIcons.IconMoon, compass: FeedIcons.IconCompass, trophy: FeedIcons.IconTrophy,
    sliders: FeedIcons.IconSliders, handshake: FeedIcons.IconHandshake,
  };
  const Cmp = map[name] || FeedIcons.IconGlobe;
  return <Cmp size={size} color={color} strokeWidth={strokeWidth} {...rest} />;
}

export default NavIcon;
